/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { a as adapterApiCall, n as noop } from '../../bridge-adpter-api-0316c034.js';
import '../../tslib.es6-e01eabb2.js';

/**
 * Windvane最底层执行，真正去调用容器能力
 */
var JSCall = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var apiName = args[0], params = args[1], _a = args[2], success = _a === void 0 ? noop : _a, _b = args[3], failure = _b === void 0 ? noop : _b;
    if (!__windvane__.call) {
        // TODO new Function 有风险，但未有好用的替代方案。此段代码copy自uni-api，风险可控。
        // eslint-disable-next-line @typescript-eslint/no-implied-eval,no-new-func
        new Function(__windvane__.windVaneCoreJs())();
    }
    __windvane__.call(apiName, params, success, failure);
};
/**
 * Windvane容器调用。
 * 跟promiseWindvane的区别，WVCall配合uni-api的extend机制，自动添加了success和fail的能力。
 * Windvane SDK：https://h5.alibaba-inc.com/api/WindVane-API.html
 */
var WVCall = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var apiName = args[0], params = args[1], successFormatOptions = args[2], errFormatOptions = args[3];
    adapterApiCall({
        apiName: apiName,
        params: params,
        JSCall: JSCall,
        successFormatOptions: successFormatOptions,
        errFormatOptions: errFormatOptions,
    });
};

export { JSCall, WVCall };
